import { PageController } from '@client/components/_core/layout/PageController';
import { Tabs } from '@client/components/_core/navigation/Tabs';
import { PERMISSIONS } from '@shared/permissions/permissions';
import { createFileRoute } from '@tanstack/react-router';
import { Zap } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/tools/auto-detect')({
    staticData: {
        breadcrumb: {
            title: 'Auto-detect',
        },
        modules: ['auto-detect'],
        permissions: [PERMISSIONS.MESSAGE_CLASSIFICATION_ACCESS],
        ui: {
            icon: Zap,
            // Every tab shares this header, so the tab strip stays put when the user switches tabs.
            title: 'Auto-detect',
            subtitle: 'Review and action messages flagged by the AI classifier',
            useTitleForChildren: true,
        },
    },
    component: ComplianceAiInbox,
});

function ComplianceAiInbox() {
    return (
        <PageController route={Route}>
            <Tabs
                items={[
                    {
                        label: 'Inbox',
                        to: '/console/$orgId/tools/auto-detect/inbox',
                    },
                    {
                        label: 'Dashboard',
                        to: '/console/$orgId/tools/auto-detect/dashboard',
                    },
                ]}
            />
        </PageController>
    );
}
